// extracted by mini-css-extract-plugin
module.exports = {"container":"container_29Ax-_","heading":"heading_2gpK9n","text":"text_2dn0ID"};